import React from "react";
import styled from "styled-components";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
const Main = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const Title = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  font-size: 0.7em;
`;
const SubIcon = styled(FaChevronUp)`
  margin-right: 4px;
  margin-left: 4px;
  left: 3px;
  color: #0adb93;
  font-size: 0.5em;
`;
const SubIconOff = styled(FaChevronDown)`
  margin-right: 4px;
  margin-left: 4px;
  left: 3px;
  color: #db0a41;
  font-size: 0.5em;
`;
const Content = styled.div`
  display: flex;
  height: 100%;
  font-size: 0.8em;
  align-items: center;
  flex-wrap: wrap;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  margin-top: auto;
  font-size: 0.7em;
`;
export default function TripleSub({ item, previewGraphic, game, events }) {
  return (
    <Main
      onClick={(e) => {
        let team = game?.home_team;
        let subs = item?.subs?.map((sub) => {
          let player = game?.lineup?.home?.find(
            (p) => p.squad?.player?.opta_ID === sub?.playerId
          );
          if (!player) {
            team = game?.away_team;
            player = game?.lineup?.away?.find(
              (p) => p.squad?.player?.opta_ID === sub?.playerId
            );
          }

          let playerOffEvent = events.find((i) => {
            return (
              i.contestantId === sub?.contestantId &&
              i.eventId ===
                parseInt(
                  sub.qualifier?.find((q) => q.qualifierId === 55)?.value
                )
            );
          });

          let playerOff = game?.lineup?.home?.find(
            (p) => p.squad?.player?.opta_ID === playerOffEvent?.playerId
          );
          if (!playerOff) {
            team = game?.away_team;
            playerOff = game?.lineup?.away?.find(
              (p) => p.squad?.player?.opta_ID === playerOffEvent?.playerId
            );
          }
          return { players: [player, playerOff] };
        });
        previewGraphic("ThreeSubstitution", {
          subs,
          team,
          game: game,
          clock: true,
        });
      }}
    >
      <Title>Triple Substitution</Title>
      <Content>
        {item?.subs?.map((sub) => {
          let player = game?.lineup?.home?.find(
            (p) => p.squad?.player?.opta_ID === sub?.playerId
          );
          if (!player) {
            player = game?.lineup?.away?.find(
              (p) => p.squad?.player?.opta_ID === sub?.playerId
            );
          }

          let playerOffEvent = events.find((i) => {
            return (
              i.contestantId === sub?.contestantId &&
              i.eventId ===
                parseInt(
                  sub.qualifier?.find((q) => q.qualifierId === 55)?.value
                )
            );
          });

          let playerOff = game?.lineup?.home?.find(
            (p) => p.squad?.player?.opta_ID === playerOffEvent?.playerId
          );
          if (!playerOff) {
            playerOff = game?.lineup?.away?.find(
              (p) => p.squad?.player?.opta_ID === playerOffEvent?.playerId
            );
          }
          return (
            <Row>
              <SubIcon />
              {player?.squad?.shirt_number ??
                player?.squad?.opta_shirt_number}. <SubIconOff />
              {playerOff?.squad?.shirt_number ??
                playerOff?.squad?.opta_shirt_number}
            </Row>
          );
        })}
      </Content>
      <Footer>
        <div>
          {item.timeMin?.toString().padStart(2, "0") +
            ":" +
            item.timeSec?.toString().padStart(2, "0")}
        </div>
      </Footer>
    </Main>
  );
}
